import React, { Fragment, useContext } from "react";

import { PropTypes } from "prop-types";

import "dayjs/locale/de";
import TabView from "../../../react_utils/TabView";

import HourlyFlow from "../flowhistory/HourlyFlow";
import DailyFlow from "../flowhistory/DailyFlow";
import MonthlyFlow from "../flowhistory/MonthlyFlow";
import AdminLocationClient from "../../../shared/api/AdminLocationClient";
import { AuthContext } from "../../../shared/contexts/AuthContext";

export default function FlowHistoryTab({ location }) {
  const { apiClient } = useContext(AuthContext);
  const locationClient = new AdminLocationClient(apiClient, location.id);
  return (
    <Fragment>
      <TabView
        components={[
          {
            title: "Tag",
            getChild: () => <HourlyFlow locationClient={locationClient} />,
          },
          {
            title: "Monat",
            getChild: () => <DailyFlow locationClient={locationClient} />,
          },
          {
            title: "Jahr",
            getChild: () => <MonthlyFlow locationClient={locationClient} />,
          },
        ]}
      />
    </Fragment>
  );
}

FlowHistoryTab.propTypes = {
  location: PropTypes.object,
};
